import { render } from "./GalleryCaption.vue?vue&type=template&id=156c8e89"
import script from "./GalleryCaption.vue?vue&type=script&lang=js"
export * from "./GalleryCaption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/modules/gallery/GalleryCaption.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "156c8e89"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('156c8e89', __exports__)) {
    api.reload('156c8e89', __exports__)
  }
  
  module.hot.accept("./GalleryCaption.vue?vue&type=template&id=156c8e89", () => {
    api.rerender('156c8e89', render)
  })

}


export default __exports__